import { cloneDeep } from "lodash";
import moment from "moment";
import { normalizeConferenceLanguageKey } from "../callHelper/conferenceLanguageKey";

export const sortNewestConversations = (conversations, missingDraftIds, temporaryConversationIds) => {
  const missingIds = missingDraftIds || []
  const tempIds = temporaryConversationIds || [];
  let mapped = conversations.map((item) => {
    if (item.last_message) {
      return item;
    } else {
      return {
        ...item,
        last_message: {
          created_at: item.created_at,
        },
      };
    }
  });
  return mapped?.sort((a, b) => {
    const aIsDraft = missingIds.includes(a.id);
    const bIsDraft = missingIds.includes(b.id);
    
    const aIsTemporary = tempIds.includes(a.id);
    const bIsTemporary = tempIds.includes(b.id);
    
    const aIsPriority = aIsDraft || aIsTemporary;
    const bIsPriority = bIsDraft || bIsTemporary;
    
    if (aIsPriority === bIsPriority) {
      return a?.last_message?.created_at < b?.last_message?.created_at ? 1 : -1;
    }
    
    return aIsPriority ? -1 : 1;
  });
};

export const sortReceivedMessages = (messages) => {
  let sorted = messages?.sort((a, b) =>
    a.device_sent_date > b.device_sent_date ? 1 : -1
  );
  return sorted;
};

export const handleReceivedMessages = (oldMessagesList, newMessgesList) => {
  const oldMessages = oldMessagesList || [];
  const newMessages = checkIsArray(newMessgesList);

  const oldMessagesById = new Map(oldMessages.map((message) => [message.id, message]));
  const newMessagesById = new Map(newMessages.map((message) => [message.id, message]));

  const uniqueMessagesIds = [
    ...new Set([...newMessagesById.keys(), ...oldMessagesById.keys()]),
  ];

  return uniqueMessagesIds
    .map((messageId) => newMessagesById.get(messageId) ?? oldMessagesById.get(messageId))
    .filter(Boolean);
};

const checkIsArray = (element) => {
  if (Array.isArray(element)) {
    return element;
  } else {
    return [element];
  }
};

const getDisplayDate = (dateMoment, locale = 'en-US') => {
  const today = moment();
  const yesterday = moment().subtract(1, "day");

  if (dateMoment.isSame(today, "day")) {
    return new Intl.RelativeTimeFormat(locale, { numeric: 'auto' }).format(0, 'day');
  } else if (dateMoment.isSame(yesterday, "day")) {
    return new Intl.RelativeTimeFormat(locale, { numeric: 'auto' }).format(-1, 'day');
  } else {
    return new Intl.DateTimeFormat(locale, { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    }).format(dateMoment.toDate());
  }
};

export const createDateSeparators = (messages, locale = 'en-US') => {
  if (!messages || messages.length === 0) {
    return [];
  }

  const copy = cloneDeep(messages);

  for (let index = 1; index < copy.length; index++) {
    const prev = copy[index - 1];
    const current = copy[index];

    const prevDate = moment(prev.device_sent_date);
    const currDate = moment(current.device_sent_date);

    if (!prevDate.isSame(currDate, "day")) {
      copy.splice(index, 0, {
        type: "date-separator",
        date: getDisplayDate(currDate, locale),
      });
      index++; // move past the inserted separator
    }
  }

  // Insert separator at the top
  const firstDate = moment(copy[0]?.device_sent_date);
  copy.splice(0, 0, {
    type: "date-separator",
    date: getDisplayDate(firstDate, locale),
  });

  return copy;
};

export const findTranslatedTextForUser = (translations, user) => {
  let translated = translations?.find((item) => item.user_id === user?.id);
  return translated;
};

export const findTranslatedTextForOtherUser = (translations, user) => {
  let translated = translations?.find((item) => item.user_id !== user.id);
  return translated;
};

export const findTranslatedTextForLanguageKey = (translations, languageKey) => {
  if (!Array.isArray(translations)) {
    return null;
  }

  const normalizedKey = normalizeConferenceLanguageKey(languageKey);
  if (!normalizedKey) {
    return null;
  }

  return (
    translations.find((item) => {
      const itemKey = normalizeConferenceLanguageKey(
        item?.language ??
          item?.translation_language ??
          item?.translationLanguage ??
          item?.locale ??
          item?.lang
      );
      return itemKey === normalizedKey;
    }) || null
  );
};

export const handleConvertBitesToMb = (bites) => {
  const Mb = bites / 1000000;
  return Mb;
};
